// components/pharmacistComponents/MedicineSearch.jsx
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import debounce from "lodash.debounce";
import { searchMedicines } from "../../Redux/actions/pharmacistActions/pharmacistMedicineActions";
import AddToCartButton from "./AddToCartButton";
import { useSanitizedInput } from "../../hooks/useSanitizedInput";

const MedicineSearch = ({ onAdd }) => {
  const dispatch = useDispatch();
  const { meds } = useSelector((state) => state.pharmacy.medsSearch || {});
  
  // ✅ Use sanitized input hook
  const [query, handleQueryChange, resetQuery] = useSanitizedInput('', 'text');
  const [open, setOpen] = useState(false);

  const doSearch = useCallback(
    debounce((q) => {
      if (!q || q.trim().length < 2) return;
      dispatch(searchMedicines(q.trim()));
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    if (query.trim().length >= 2) {
      doSearch(query);
      setOpen(true);
    } else {
      setOpen(false);
    }
    return () => doSearch.cancel();
  }, [query, doSearch]);

  const handleAddClick = (e, med) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const startPos = {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    };
    if (onAdd) onAdd(med, startPos);
  };

  return (
    <div style={{ position: "relative" }}>
      <input
        className="form-control"
        placeholder="Search by name, company, or category..."
        value={query}
        onChange={handleQueryChange} // ✅ Using hook's handleChange
        maxLength={100}
        style={{
          borderRadius: "10px",
          padding: "0.75rem 1rem",
          border: "2px solid #e0e0e0",
          fontSize: "0.95rem"
        }}
      />

      {open && (
        <div 
          className="list-group" 
          style={{ 
            maxHeight: 300, 
            overflowY: "auto",
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1000,
            marginTop: "0.5rem",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            borderRadius: "10px"
          }}
        >
          {meds && meds.length > 0 ? (
            meds.map((m) => (
              <div
                key={m._id}
                className="list-group-item d-flex justify-content-between align-items-center"
                style={{ 
                  opacity: Number(m.stock) === 0 ? 0.6 : 1,
                  border: "none",
                  borderBottom: "1px solid #f0f0f0"
                }}
              >
                <div style={{ flex: 1 }}>
                  <strong>{m.name}</strong>
                  <div className="small text-muted">{m.company || m.category}</div>
                  <div className="small">
                    <span className="text-success">Rs {m.price}</span>
                    <span className="mx-2">|</span>
                    <span className={m.stock <= 5 ? "text-danger" : ""}>
                      Stock: {m.stock}
                    </span>
                  </div>
                </div>

                <div>
                  <AddToCartButton
                    disabled={Number(m.stock) === 0}
                    onClick={(e) => handleAddClick(e, m)}
                  />
                </div>
              </div>
            ))
          ) : (
            <div className="list-group-item small text-muted text-center">
              No matches found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MedicineSearch;